import { Component, OnInit } from '@angular/core';
import { TenGameClubQuery, TenGameClub } from '@fgb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgb-ten-game-club',
  templateUrl: './ten-game-club.component.html',
  styleUrls: ['./ten-game-club.component.scss'],
})
export class TenGameClubComponent implements OnInit {
  tenGameClubs$: Observable<TenGameClub[]>;

  constructor(private tenGameClubQuery: TenGameClubQuery, private modalService: NgbModal) {}

  ngOnInit() {
    this.tenGameClubs$ = this.tenGameClubQuery.selectAllTenGameClubs().pipe(map((g) => g.slice(0, 8))); // Slice purely for design, needs removing
  }
  open(content: any) {
    this.modalService.open(content);
  }
}
